module.exports = __webpack_public_path__ + "static/media/learnovate.cefe1d3c.png";